import { normalizarEstadoPractica, getEstadoVencimiento } from './formatters';

export const filtrarPorBusqueda = (rows, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') return rows;

  const termLower = searchTerm.toLowerCase().trim();

  return rows.filter(row => {
    const valores = [
      row.cronogramaId?.toString(),
      row.convenioId?.toString(),
      row.practicaEstado,
      row.institucion,
      row.nombreServicio,
      row.carrera,
      row.nombreApellido,
      row.cedulaIdentidad,
      row.nacionalidad,
      row.materia,
      row.tutor,
      row.ciTutor?.toString(),
      row.fechaDesde,
      row.fechaHasta,
      row.fechaFinVigencia,
    ];

    return valores.some(valor =>
      valor && valor.toString().toLowerCase().includes(termLower)
    );
  });
};

export const filtrarPorFiltrosAvanzados = (rows, filtros) => {
  let resultado = [...rows];

  if (Array.isArray(filtros.estados) && filtros.estados.length > 0) {
    resultado = resultado.filter(row => filtros.estados.includes(row.practicaEstado));
  }

  if (filtros.ciEstudiante && filtros.ciEstudiante.trim() !== '') {
    const ciNormalizada = filtros.ciEstudiante.toString().replace(/[^0-9a-zA-Z]/g, '').toLowerCase();
    resultado = resultado.filter(row => {
      const ciAlumno = (row.cedulaIdentidad || '').toString().replace(/[^0-9a-zA-Z]/g, '').toLowerCase();
      return ciAlumno.includes(ciNormalizada);
    });
  }

  if (filtros.cronogramaId && filtros.cronogramaId.trim() !== '') {
    const cronograma = filtros.cronogramaId.toString().trim();
    resultado = resultado.filter(row =>
      row.cronogramaId?.toString().includes(cronograma)
    );
  }

  if ((!Array.isArray(filtros.estados) || filtros.estados.length === 0) && filtros.estadoPractica && filtros.estadoPractica !== 'todos') {
    resultado = resultado.filter(row => {
      const estadoNormalizado = normalizarEstadoPractica(row.practicaEstado);
      return estadoNormalizado === filtros.estadoPractica;
    });
  }

  if (filtros.institucion && filtros.institucion !== 'todas') {
    resultado = resultado.filter(row =>
      row.institucion === filtros.institucion
    );
  }

  if (filtros.carrera && filtros.carrera !== 'todas') {
    resultado = resultado.filter(row =>
      row.carrera === filtros.carrera
    );
  }

  if (filtros.servicio && filtros.servicio !== 'todos') {
    resultado = resultado.filter(row =>
      row.nombreServicio === filtros.servicio
    );
  }

  if (filtros.anio && filtros.anio !== 'todos') {
    resultado = resultado.filter(row =>
      row.anio?.toString() === filtros.anio.toString()
    );
  }

  if (filtros.estadoVencimiento && filtros.estadoVencimiento !== 'todos') {
    resultado = resultado.filter(row => {
      const estadoVencimiento = getEstadoVencimiento(row.fechaFinVigencia);
      return estadoVencimiento === filtros.estadoVencimiento;
    });
  }

  if (filtros.nacionalidad && filtros.nacionalidad !== 'todas') {
    resultado = resultado.filter(row =>
      row.nacionalidad === filtros.nacionalidad
    );
  }

  if (filtros.rectificado && filtros.rectificado !== 'todos') {
    if (filtros.rectificado === 'si') {
      resultado = resultado.filter(row => row.rectificado === true);
    } else if (filtros.rectificado === 'no') {
      resultado = resultado.filter(row => !row.rectificado);
    }
  }

  return resultado;
};

export const obtenerValoresUnicos = (rows, campo) => {
  const valores = rows
    .map(row => row[campo])
    .filter(valor => valor !== null && valor !== undefined && valor !== '');

  return [...new Set(valores)].sort();
};

export const obtenerOpcionesFiltro = (rows) => {
  return {
    instituciones: obtenerValoresUnicos(rows, 'institucion'),
    carreras: obtenerValoresUnicos(rows, 'carrera'),
    servicios: obtenerValoresUnicos(rows, 'nombreServicio'),
    anios: obtenerValoresUnicos(rows, 'anio'),
    nacionalidades: obtenerValoresUnicos(rows, 'nacionalidad'),
  };
};

export const hayFiltrosActivos = (filtros) => {
  return Object.values(filtros).some(valor => {
    if (Array.isArray(valor)) return valor.length > 0;
    return valor && valor !== 'todos' && valor !== 'todas';
  });
};

export const limpiarFiltros = () => {
  return {
    periodoDesde: '',
    periodoHasta: '',
    estadoPractica: 'todos',
    estado: 'todos',
    estados: [],
    ciEstudiante: '',
    cronogramaId: '',
    institucion: 'todas',
    carrera: 'todas',
    servicio: 'todos',
    anio: 'todos',
    estadoVencimiento: 'todos',
    nacionalidad: 'todas',
    rectificado: 'todos',
  };
};
